import { Invoice } from 'fs-api-client';
import { createDefaultApi } from '../webportal/utils/createApi';
import PaymentStatusEnum = Invoice.PaymentStatusEnum;

export class BillingService {

    static async fetchInvoices(userId: string): Promise<Invoice[]> {
        const api = await createDefaultApi();
        return (await api.getUserInvoices(userId)).body;
    }

    static calculateTotalPaid(invoices: Invoice[]): number {
        let totalPaid = 0;
        invoices.forEach((invoice) => {
            if (invoice.paymentStatus === PaymentStatusEnum.Paid) {
                totalPaid += invoice.amountDue;
            }
        });
        return totalPaid;
    }

    static getInvoicesAboveZeroAmount(invoices: Invoice[]): number {
        return invoices.filter(invoice => invoice.amountDue > 0).length;
    }

}



// WEBPACK FOOTER //
// ./src/backoffice/BillingService.ts